import {
  AuthorizationFailedReason,
  IncidentType
} from "@moderrotech/servers-communication-library/src/types";

export const ja = {
  topics: {
    headerTitle: "トピック",
    search: "検索",
    noTopics: "トピックが見つかりません",
    notFound: "パターンに一致するトピックが見つかりませんでした",
    schedule: {
      closed: "利用不可"
    },
    customerInfoForm: {
      title: "ビデオ通話を始める前に...",
      description:
        "ビデオ バンキングを使用してローンを申し込む前に、フォームに必要事項を記入してください。",
      optional: "任意",
      buttons: {
        cancel: "キャンセル",
        submit: "ビデオ通話を開始する"
      }
    }
  },
  call: {
    calling: "呼び出し中",
    joining: "通話に参加中",
    transferring: "通話を転送中",
    aspectRatio: "ズーム",
    cancel: "キャンセル",
    end: "終了",
    share: "マルチパーティーコール",
    document: "ドキュメント",
    actions: "アクション",
    closeActions: "キャンセル",
    mute: "ミュート",
    unmute: "ミュート解除",
    textMessage: "テキストメッセージ",
    queuePosition: (ctx: { list: Function }) => {
      const position = ctx.list(0);
      const isPositionAvailable = ctx.list(1);
      return `あなたの順番は${
        isPositionAvailable ? ` ${position} ` : ""
      }番目です`;
    },
    ticket: "チケット",
    camera: {
      enable: "カメラを有効にする",
      disable: "カメラを無効にする"
    },
    hangupRequest: {
      title: "終了の確認",
      body: "本当に通話を終了しますか？",
      yes: "はい、終了します",
      no: "いいえ、通話を続けます"
    },
    downloadFileRequest: {
      title: "オペレーターがファイルを共有しました",
      yes: "ダウンロード",
      no: "拒否"
    },
    openUrlRequest: {
      title: "URLを開く",
      body: "オペレーターが新しいタブで URL を開こうとしています",
      yes: "URLを開く",
      no: "キャンセル"
    },
    lowPerformanceNotification: {
      title:
        "デバイスのパフォーマンスが低いようです。アプリのクラッシュを避けるため、カメラを使用しないでください。",
      gotIt: "了解"
    },
    signaturePad: {
      submit: "送信",
      clear: "クリア",
      cancel: "キャンセル"
    },
    paintover: {
      submit: "送信",
      clear: "クリア",
      cancel: "キャンセル"
    },
    textMessageForm: {
      placeholder: "メッセージを送信する"
    },
    recordTranslator: {
      transcribing: "お話しください"
    },
    cameraSnapshot: {
      title: "カメラのスナップショット"
    },
    mediaInputsAccessNote: {
      title: "マイクとカメラへのアクセスを許可してください",
      description:
        "ブラウザのアドレス バーの近くにある小さなポップアップを探してください。"
    },
    animatedCharacter: {
      listening: {
        title: "オペレーターが聞いています",
        description: "お話しいただけます。ご質問やご要望をお話しください。"
      },
      thinking: {
        title: "オペレーターが考えています",
        description: "オペレーターが回答を探しています。少々お待ちください。"
      }
    },
    success: {
      document: "ドキュメントが正常に送信されました",
      feedback: "フィードバックが送信されました",
      textMessage: "テキストメッセージが送信されました",
      signaturePad: "署名が送信されました",
      paintover: "画像が送信されました",
      textCopy: "テキストがクリップボードにコピーされました",
      imageCopy: "画像はクリップボードにコピーされました",
      callSharing: "リンクがクリップボードにコピーされました"
    },
    error: {
      base: "問題が発生しました。ページを再読み込みしてください",
      mediaInputsAccess:
        "マイクやカメラにアクセスできません。設定で有効にしてください",
      join: "通話に参加できません",
      document: "ドキュメントを送信できません",
      noExperts: "応答できるオペレーターが不在です",
      noTopic: "トピックは利用できなくなりました",
      queueSuspended:
        "キューが一時停止されました<br>現在、新しい電話を受けることができません。後でもう一度試してください。",
      queueOverloaded:
        "キューが過負荷です<br>大量の通話が発生しています。後でもう一度試してください。",
      timeout: "時間内にオペレーターが応答できませんでした",
      documentSize: "ドキュメントのサイズが大きすぎます",
      feedback: "問題が発生しました。ページを再読み込みしてください",
      noRoom: "予約の有効期限が切れたか、医師によってキャンセルされました",
      textMessage: "テキストメッセージを送信できません",
      signaturePad: "署名を送信できません",
      paintover: "画像送信エラー",
      textCopy: "テキストをコピーできません",
      imageCopy: "画像をコピーできません",
      callSharing: "リンクをシェアできません",
      recordTranslation: {
        play: "翻訳済み音声を再生できません",
        streamGetting: "音声ストリームを取得できません",
        transcription: "データを転記できません",
        translation: "データを翻訳できません",
        unsupportedLanguage:
          "選択された言語は音声翻訳でサポートされていません。ただし、相手側の音声はこの言語で翻訳できます"
      },
      geolocation: "地理位置情報を取得できません",
      cameraSnapshot: "カメラのスナップショットを取得できません"
    },
    onHold: {
      title: "保留中",
      description: "少々お待ちください。"
    },
    remoteActionRequest: {
      shareFile: {
        title:
          "オペレーターがファイルの共有をリクエストしています。許可しますか？",
        yes: "はい",
        no: "いいえ"
      },
      screenSharing: {
        title: "オペレーターが画面の共有をリクエストしています。許可しますか？",
        yes: "はい",
        no: "いいえ"
      }
    },
    settings: {
      title: "設定",
      labels: {
        camera: "カメラ",
        microphone: "マイク"
      }
    }
  },
  thank: {
    toTopics: "トピックに戻る",
    redirect: "予約画面に移動する"
  },
  ticket: {
    creationRequest: {
      title: (ctx: { list: Function }) => {
        const incidentType = ctx.list(0);
        return incidentType === IncidentType.queueTimeout
          ? "タイムアウトしました。"
          : "応答できるオペレーターが不在です。";
      },
      body:
        "メッセージを残していただければ、こちらから折り返しご連絡をいたします。",
      yes: "チケットを作成する",
      no: "チケットを作成しない"
    },
    form: {
      labels: {
        phone: "電話",
        email: "Eメール",
        message: "メッセージ"
      },
      buttons: {
        cancel: "キャンセル",
        submit: "メッセージを送信する"
      }
    }
  },
  feedback: {
    form: {
      fields: {
        email: {
          label: "から：",
          validation: {
            label: "電子メール"
          }
        },
        message: {
          label: "メッセージ",
          placeholder: "メッセージ",
          validation: {
            label: "メッセージ"
          }
        }
      },
      buttons: {
        submit: "送信",
        cancel: "キャンセル",
        open: "フィードバックメッセージを追加..."
      },
      notifications: {
        success: "バグレポートが送信されました"
      }
    }
  },
  error: {
    connection: {
      title: (ctx: { list: Function }) => {
        const isOnCall = ctx.list(0);
        return isOnCall
          ? "ネットワークに問題が発生しました。回復しだいオペレーターに再度繋がります。"
          : "サービスが一時的に利用できなくなります";
      },

      description: (ctx: { list: Function }) => {
        const isOnCall = ctx.list(0);
        return isOnCall
          ? "接続を復元しようとしています。"
          : "接続が失われました。再接続中...";
      },
      code: "コード: 503"
    },
    login: {
      credentials: "ユーザー名かパスワードが正しくありません",
      default: "問題が発生しました"
    },
    unpublished: {
      title: "アプリケーションが存在しません。",
      description:
        "一時的に非公開になっているか、完全に削除されている可能性があります。",
      code: "コード: 404"
    },
    authorization: {
      title: "アクセス禁止",
      description: (ctx: { list: Function }) => {
        const reason = ctx.list(0) as
          | AuthorizationFailedReason.geofencingFailed
          | AuthorizationFailedReason.noLicense
          | AuthorizationFailedReason.remStopped
          | AuthorizationFailedReason.noPtpcResponse;
        return {
          [AuthorizationFailedReason.geofencingFailed]:
            "このアプリケーションはお住まいの国または地域では利用できません。",
          [AuthorizationFailedReason.noLicense]:
            "ライセンスが割り当てられていません。",
          [AuthorizationFailedReason.remStopped]: "サービスは利用できません。",
          [AuthorizationFailedReason.noPtpcResponse]:
            "サーバー応答がありません。"
        }[reason];
      },
      code: "コード: 403"
    },
    network: {
      title: "インターネットにアクセスできることを確認してください"
    }
  },
  validation: {
    phone: "{field} フィールドは有効な電話番号である必要があります",
    dni: "間違ったID、無効な形式",
    nie: "間違ったID、無効な形式"
  }
};
